import {
  RepairSparePartAutocompleteCustomFilters,
  RepairSparePartAutocompleteCustomFiltersValuesEnablementMap,
} from "@/common/components/Entity/RepairSparePart/RepairSparePartAutocompleteCustomFiltersInput";

import { RepairHelper } from "./repair";

/** Settings for repair spare part autocomplete filters. */
export interface RepairSparePartAutocompleteSettings {
  /** @deprecated Use `filtersEnablement`. Enabled filters (v1). */
  filters?: {
    partType?: boolean;
    make?: boolean;
    model?: boolean;
  };

  /** User custom filters (v2). */
  customFilters?: {
    enablementMap?: Partial<RepairSparePartAutocompleteCustomFiltersValuesEnablementMap>;
  };
}

export class RepairSparePartHelper {
  public static getAutocompleteSettings(): Nil<RepairSparePartAutocompleteSettings> {
    const localSettings = RepairHelper.getLocalSettings();
    const settings = localSettings?.repairSparePartAutocompleteSettings;
    return settings
      ? {
          ...settings,
          // migrate to v2
          customFilters:
            settings.customFilters ||
            (settings.filters
              ? {
                  enablementMap: {
                    partTypeId: settings.filters.partType,
                    makeId: settings.filters.make,
                    modelId: settings.filters.model,
                  },
                }
              : undefined),
        }
      : undefined;
  }

  public static saveAutocompleteSettings(settings: RepairSparePartAutocompleteSettings): void {
    const localSettings = RepairHelper.getLocalSettings() || {};
    localSettings.repairSparePartAutocompleteSettings = settings;
    RepairHelper.saveLocalSettings(localSettings);
  }

  public static saveAutocompleteCustomFilters(
    filters: Nil<RepairSparePartAutocompleteCustomFilters>,
  ): void {
    const localSettings = RepairHelper.getLocalSettings() || {};
    const settings = localSettings?.repairSparePartAutocompleteSettings;
    localSettings.repairSparePartAutocompleteSettings = {
      ...settings,
      customFilters: {
        ...settings?.customFilters,
        enablementMap: filters?.enablementMapForPersistence,
      },
    };
    RepairHelper.saveLocalSettings(localSettings);
  }
}
